import { UseCase } from '../UseCase';
import { Balance } from '../../models/Balance';
import { BalanceRepository } from '../../repositories/BalanceRepository';
export class GetBalanceUseCase implements UseCase<GetBalanceRequestDto, Balance>{

    constructor(
        private balanceRepo:BalanceRepository
    ){}
    async execute(t: GetBalanceRequestDto): Promise<Balance> {
        return this.balanceRepo.getBalance(t.token);
    }

}

export class GetBalanceRequestDto{
    constructor(
        public token:string,
    ){}
}